import styled from 'styled-components'

export const Container = styled.div`
  margin: 4px auto 30px;
`
